<template>
  <VDialog v-model="isVisible" :retain-focus="false" width="500" attach="#LetsPage">
    <!-- Zoom -->
    <VCard v-if="isVisible && dialogData.meeting_platform === 'ZOOM'">
      <VCardTitle>{{ $t('M00501.MeetingInfoDialog.-tW8MJnYpNekv4LLnvLYc') }}</VCardTitle>
      <VCardText v-debug>
        <h3>dialogData</h3>
        {{dialogData.item}}
      </VCardText>
      <VCardText>
        <!-- <VRow v-for="(value, key) in meetingDetailJson" :key="key" class="my-1">
          <VCol cols="5" class="font-weight-bold text-right">{{ key }}:</VCol>
          <VCol cols="7">{{ value }}</VCol>
        </VRow>
        <VRow v-if="Object.keys(meetingDetailJson).length === 0">
          <VCol class="text-center">No zoom information available</VCol>
        </VRow> -->
        <div class="my-2">
          <h3 class="font-weight-bold color-primary">
            {{ $t('M00501.MeetingInfoDialog.0KRx2QUHu5e-NKLJr3obO') }} </h3>
          <div>
            <DataWarp :value="meetingDetailJson.host_email"></DataWarp>
          </div>
        </div>
        <div class="my-2">
          <h3 class="font-weight-bold color-primary">
            {{ $t('M00501.MeetingInfoDialog._x-1VptPP8uxwZV-UsGk2') }} </h3>
          <div>
            <DataWarp :value="dialogData.item.meeting_room_id"></DataWarp>
          </div>
        </div>
        <div class="my-2">
          <h3 class="font-weight-bold color-primary">
            {{ $t('M00501.MeetingInfoDialog.sLdYjSZHiS31rBleUyDMq') }} </h3>
          <div>
            <DataWarp :value="dialogData.item.meeting_room_passcode"></DataWarp>
          </div>
        </div>
        <div class="my-2">
          <h3 class="font-weight-bold color-primary">
            {{ $t('M00501.MeetingInfoDialog.LViABBNRizjqNGfJ6UkI0') }} </h3>
          <div>
            <DataWarp type="url" :value="meetingDetailJson.join_url"></DataWarp>
          </div>
        </div>
        <div class="my-2">
          <h3 class="font-weight-bold color-primary">
            {{ $t('M00501.MeetingInfoDialog.ZiXIvfuJ3sXQYASbfZVJl') }} </h3>
          <div>
            <DataWarp type="url" :value="meetingDetailJson.start_url"></DataWarp>
          </div>
        </div>
      </VCardText>
      <!-- <VCardText v-debug>
        <h3>outputData</h3>
        {{outputData}}
      </VCardText> -->
      <VCardActions>
        <VSpacer></VSpacer>
        <VBtn
          @click="copyToClipboard([
            $t('M00501.MeetingInfoDialog.0KRx2QUHu5e-NKLJr3obO'),
            meetingDetailJson.host_email,'',
            $t('M00501.MeetingInfoDialog._x-1VptPP8uxwZV-UsGk2'),
            dialogData.item.meeting_room_id,'',
            $t('M00501.MeetingInfoDialog.sLdYjSZHiS31rBleUyDMq'),
            dialogData.item.meeting_room_passcode,'',
            $t('M00501.MeetingInfoDialog.LViABBNRizjqNGfJ6UkI0'),
            meetingDetailJson.join_url,'',
            $t('M00501.MeetingInfoDialog.ZiXIvfuJ3sXQYASbfZVJl'),
            meetingDetailJson.start_url,'',
          ].join('\n'))"
        >
          {{ $t('M00501.MeetingInfoDialog.qs4pDOwKnLEcZfk3Otfau') }} <!-- <VIcon>mdi-content-copy</VIcon> -->
        </VBtn>
        <VBtn
          color="primary"
          @click="emitOk"
        >
          {{$t('common.ok')}}
        </VBtn>
      </VCardActions>
    </VCard>
    <!-- Google Meet -->
    <VCard v-if="isVisible && dialogData.meeting_platform === 'GOOGLE_MEET'">
      <VCardTitle>{{ $t('M00501.MeetingInfoDialog.GQUflz037SEuCpwRZME0a') }}</VCardTitle>
      <VCardText v-debug>
        <h3>dialogData</h3>
        {{dialogData.item}}
      </VCardText>
      <VCardText>
        <div class="my-2">
          <h3 class="font-weight-bold color-primary">
            {{ $t('M00501.MeetingInfoDialog.0lxbHP6ojPl5rP8gIlI8M') }} </h3>
          <div>
            <DataWarp :value="meetingDetailJson.host_email"></DataWarp>
          </div>
        </div>
        <div class="my-2">
          <h3 class="font-weight-bold color-primary">
            {{ $t('M00501.MeetingInfoDialog.CuzZo7GBR6dPOvl965tKc') }} </h3>
          <div>
            <DataWarp :value="meetingDetailJson.meetingCode"></DataWarp>
          </div>
        </div>
        <div class="my-2">
          <h3 class="font-weight-bold color-primary">
            {{ $t('M00501.MeetingInfoDialog.bor29x1X3TbcBDLqU4LWo') }} </h3>
          <div>
            <DataWarp type="url" :value="meetingDetailJson.meetingUri"></DataWarp>
          </div>
        </div>
      </VCardText>
      <!-- <VCardText v-debug>
        <h3>outputData</h3>
        {{outputData}}
      </VCardText> -->
      <VCardActions>
        <VSpacer></VSpacer>
        <VBtn
          @click="copyToClipboard([
            $t('M00501.MeetingInfoDialog.0lxbHP6ojPl5rP8gIlI8M'),
            meetingDetailJson.host_email,'',
            $t('M00501.MeetingInfoDialog.CuzZo7GBR6dPOvl965tKc'),
            meetingDetailJson.meetingCode,'',
            $t('M00501.MeetingInfoDialog.bor29x1X3TbcBDLqU4LWo'),
            meetingDetailJson.meetingUri,'',
          ].join('\n'))"
        >
          {{ $t('M00501.MeetingInfoDialog.qs4pDOwKnLEcZfk3Otfau') }} <!-- <VIcon>mdi-content-copy</VIcon> -->
        </VBtn>
        <VBtn
          color="primary"
          @click="emitOk"
        >
          {{$t('common.ok')}}
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script>
import DialogMixin from '@/mixins/DialogMixin.js';
export default {
  mixins:[
    DialogMixin
  ],
  data () {
    return {
    }
  },
  computed: {
    cDialogData() {
      return this.dialogData.item || {};
    },
    meetingDetailJson() {
      if (this.dialogData.item.meeting_detail_json) {
        try {
          return JSON.parse(this.dialogData.item.meeting_detail_json);
        } catch (e) {
          console.error(this.$t('M00501.MeetingInfoDialog.fnAzO3h4ygHq4SWhDA2jy'), e);
          return {};
        }
      }
      return {};
    }
  },
  mounted() {
  },
  methods: {
    copyToClipboard: function (text) {
      if (navigator.clipboard && window.isSecureContext) {
        // Use the Clipboard API when available
        navigator.clipboard.writeText(text).then(() => {
          this.$dialog.notify.success(this.$t('M00501.MeetingInfoDialog.F9xU45XLyobyJWQ256tb8'))
        }).catch(() => {
          this.$dialog.notify.error(this.$t('M00501.MeetingInfoDialog.42FoiQzE6tAzWCGFsusnL'))
        })
      } else {
        // Fallback for older browsers
        const textArea = document.createElement('textarea')
        textArea.value = text
        textArea.style.position = 'fixed'
        textArea.style.left = '-999999px'
        textArea.style.top = '-999999px'
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()
        try {
          document.execCommand('copy')
          this.$dialog.notify.success(this.$t('M00501.MeetingInfoDialog.F9xU45XLyobyJWQ256tb8'))
        } catch (err) {
          this.$dialog.notify.error(this.$t('M00501.MeetingInfoDialog.42FoiQzE6tAzWCGFsusnL'))
        }
        textArea.remove()
      }
    },
  }
}
</script>

<style>

</style>
